<template>
  <div class="documentBlock">
    <div v-for="(el, index) in items" :key="index">
      <div v-html="el.name"></div>
      <div v-html="el.content"></div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'

export default {
  setup(props, context) {
    const { $store } = context.root
    const routeName = context.root.$route.name
    const items = ref([])

    const getOwnerOffer = useRequest({
      context,
      request: () => $store.dispatch('data/getDocument', { document: 'oferta_owner' }),
    })
    const getClientOffer = useRequest({
      context,
      request: () => $store.dispatch('data/getDocument', { document: 'oferta_client' }),
    })
    const getPrivacyPolicy = useRequest({
      context,
      request: () => $store.dispatch('data/getDocument', { document: 'privacy_policy' }),
    })
    const getAgreement = useRequest({
      context,
      request: () => $store.dispatch('data/getDocument', { document: 'agreement' }),
    })

    onMounted(async () => {
      switch (routeName) {
        case 'ownerOffer': {
          const response = await getOwnerOffer.makeRequest()
          items.value = response
          break
        }
        case 'clientOffer': {
          const response = await getClientOffer.makeRequest()
          items.value = response
          break
        }
        case 'privacyPolicy': {
          const response = await getPrivacyPolicy.makeRequest()
          items.value = response
          break
        }
        case 'agreement': {
          const response = await getAgreement.makeRequest()
          items.value = response
          break
        }
        default: {
          break
        }
      }
    })
    return {
      items,
    }
  },
}
</script>

<style lang="scss">
.documentBlock{
  padding: 10px 16px;
  background-color: #fff;
}
</style>
